import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appCurrencyFormatter]'
})
export class CurrencyFormatterDirective {
  constructor(private el: ElementRef, private control: NgControl, private renderer: Renderer2) {}

  // Prevent alphabetic characters from being entered
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete']; // Allow navigation keys
    const isNumber = event.key.match(/[0-9]/);
    const isComma = event.key === ',';

    if (!isNumber && !isComma && !allowedKeys.includes(event.key)) {
      event.preventDefault(); // Block invalid input
    }
  }

  @HostListener('focus') onFocus() {
    let value = this.el.nativeElement.value.replace(/,/g, ''); // Remove commas while editing
    this.renderer.setProperty(this.el.nativeElement, 'value', value);
  }

  @HostListener('blur') onBlur() {
    let value = this.el.nativeElement.value.trim();

    // Remove any invalid characters before processing
    value = value.replace(/[^0-9]/g, '');

    if (!isNaN(+value) && value !== '') {
      let formattedValue = this.formatIndianCurrency(value);

      // ✅ Set formatted value in the input field
      this.renderer.setProperty(this.el.nativeElement, 'value', formattedValue);

      // ✅ Store raw numeric value in form control (without commas)
      // this.control.control?.setValue(+value);
    } else {
      this.renderer.setProperty(this.el.nativeElement, 'value', '');
      // this.control.control?.setValue(null);
    }
  }

  private formatIndianCurrency(value: string): string {
    let numberValue = parseFloat(value);
    if (isNaN(numberValue)) return value;

    return new Intl.NumberFormat('en-IN').format(numberValue); // Indian-style commas
  }
}
